/*eslint-disable */
import React, {useCallback, useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setIsLoading} from "../../Layout/actions";
import {appMonitorLogger, getCookie, setCookie, trackClickEvent} from "../../../utils/utils";
import {getRequest, postRequest} from "../../../utils/request";
import ApiConfig from "../../../config/apiConfig";
import {Button} from "../../HTMLEntities/Button";
import RequestACallBackCTAPopUp from "./widgets/RequestACallBackCTAPopUp/Loadable";
import Popup from "../../PopUp/Loadable";
import {
    CHECK_TO_SHOW_SIGN_UP_FORM,
    REDIRECT_TO_FINAL_PAGE,
    RequestACallbackTrackingData,
    SKIP_CHECK_TO_SHOW_SIGN_UP_FORM,
    TrackingData,
} from "../types";
import {
    CounselorId,
    CourseId,
    GlobalLayoutPropsInterface,
    REQUEST_A_CALLBACK,
    TAG_AND_TRACK_HIL_THEME,
    TrackingId,
} from "../../../types";
import {RootStore} from "../../../configureStore";
import {addReferralTitleAndUrl, createLeadAndResponse} from "../response";
import {useHistory, useLocation} from "react-router";
import {
    ClickCallbackRCB,
    CounselorHierarchy,
    RequestACallbackValidateAPIResponse,
    PopUpTypes,
    RequestACallbackQueryParams,
} from "./types";
import {parseQueryString} from "../../../utils/string";
import Anchor from "../../HTMLEntities/Anchor";
import {useEventTracking} from "../../../hooks/useEventTracking";
import {appCTAHandle} from "../../../utils/utils";
import {PageContextTrackingDTO} from "../../../containers/RegistrationLoginPage/types";

interface Props extends Omit<TrackingData, "sourcePage" | "trackingId"> {
    eventAction: string;
    courseId?: CourseId;
    counselorId?: CounselorId;
    autoTriggerBasedOnParams?: boolean;
    trackingId: {
        requestACallBack: TrackingId;
        register: TrackingId;
    };
    buttonLabel?: string;
    viewType?: string;
    // showMoreThanOneCounsellor?: boolean;
}

const RequestACallBackCTA: React.FC<Props> = (props: Props) => {
    const {
        eventCategory,
        eventAction,
        widget,
        trackingId,
        counselorId,
        courseId,
        autoTriggerBasedOnParams = false,
        buttonLabel = "Request a Call Back",
        viewType = "button",
        // showMoreThanOneCounsellor = false
    } = props;
    const [isPopUpOpened, setIsPopUpOpened] = useState(false);
    const [counselorHierarchy, setCounselorHierarchy] = useState<CounselorHierarchy[] | null>(null);

    const [showMoreThanOneCounsellor, setShowMoreThanOneCounsellor] = useState<boolean>(false);

    const [applicableTrackingId, setApplicableTrackingId] = useState(trackingId.requestACallBack);
    const [popUpType, setPopUpType] = useState<PopUpTypes>("failed");
    const [reviewPageCounsellorId, setReviewPageCounsellorId] = useState<number | null>(null);
    const dispatch = useDispatch();
    const isMobile = useSelector(
        (state: RootStore) => (state.layout?.isMobile as boolean | undefined) ?? false,
    );
    const reactivationDatePassed = useSelector(
        (state: RootStore) =>
            state.layout?.userAndShortlistData?.userRMCData?.reactivationDatePassed ?? null,
    );

    const userStageId = useSelector(
        (state: RootStore) => state.layout?.userAndShortlistData?.userRMCData?.stageId ?? null,
    );

    const history = useHistory();
    const location = useLocation();
    const isUserLoggedIn = useSelector(
        (state: RootStore) => state.layout?.userAndShortlistData?.userLoggedIn ?? false,
    );
    const userId = useSelector(
        (state: RootStore) => state.layout?.userAndShortlistData?.userBasicDetail?.userId ?? 0,
    );

    const pageName = useSelector(
        (state: RootStore) =>
            (state.layout.globalLayoutProps as GlobalLayoutPropsInterface)?.pageName,
    );

    const enableCTA = useRef(true);
    const loaderTimeout = useRef(0);

    const resetFn = useCallback(() => {
        enableCTA.current = true;
        clearTimeout(loaderTimeout.current);
        dispatch(setIsLoading(false));
    }, [dispatch]);
    const triggerEvent = useEventTracking();

    const onCTAClick = useCallback(
        async ({
            trackingId,
            showSignUpCheck = true,
            courseId,
            counselorId,
            eventCategory,
            eventAction,
            widget,
        }: ClickCallbackRCB) => {
            let pageContextTrackingObj = {} as PageContextTrackingDTO;
            if (typeof pageName !== "undefined" && pageName !== "") {
                pageContextTrackingObj["pageIdentifer"] = pageName;
                setCookie("pageContextTrackingObj", btoa(JSON.stringify(pageContextTrackingObj)));
            }
            if (counselorId !== null && counselorId !== 0) {
                setReviewPageCounsellorId(counselorId ?? null);
            }
            RequestACallBackCTAPopUp.preload();
            Popup.preload();
            if (!enableCTA.current) {
                return false;
            }
            enableCTA.current = false;
            loaderTimeout.current = window.setTimeout(function () {
                dispatch(setIsLoading(true));
            }, 1000);

            //eventAction should also be used in other CTAs too
            trackClickEvent(eventCategory, eventAction, widget);

            void triggerEvent({
                theme: TAG_AND_TRACK_HIL_THEME,
                category: "click",
                widget: REQUEST_A_CALLBACK,
                label: REQUEST_A_CALLBACK,
                eventName: "click",
            });
            const trackingData: RequestACallbackTrackingData = {
                eventCategory,
                eventAction,
                widget,
                counselorId,
                trackingId: trackingId.register,
                courseId,
                ...addReferralTitleAndUrl(""),
                ctaType: REQUEST_A_CALLBACK as typeof REQUEST_A_CALLBACK,
            };
            // if (userStageId === 10 && !reactivationDatePassed) {
            //     resetFn();
            //     setPopUpType("reactivationDate");
            //     setIsPopUpOpened(true);
            // } else {
            const response = await createLeadAndResponse({
                trackingData,
                dispatch,
                isMobile,
                history,
                type:
                    showSignUpCheck || !isUserLoggedIn
                        ? CHECK_TO_SHOW_SIGN_UP_FORM
                        : SKIP_CHECK_TO_SHOW_SIGN_UP_FORM,
            });

            if (response === REDIRECT_TO_FINAL_PAGE) {
                if (!userId) {
                    resetFn();
                    return;
                }
                try {
                    const data = (await getRequest(
                        ApiConfig.VALIDATE_USER_FOR_GET_A_CALLBACK_CTA,
                    )) as {
                        data: {data: RequestACallbackValidateAPIResponse};
                    };
                    const {
                        isEligible,
                        ineligibilityType,
                        counselorHierarchy = null,
                        leadQuality = "",
                    } = data.data?.data ?? {
                        isEligible: false,
                        ineligibilityType: "Type_-1",
                    };
                    if (isEligible) {
                        const data = {
                            userId: userId,
                            docPath: "",
                            examId: "",
                            courseId: courseId,
                            counselorId: counselorId,
                            profileEvaluationTrackingId: trackingId.requestACallBack,
                            leadQuality: leadQuality,
                        };
                        const axiosConfig = {
                            headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                            },
                            withCredentials: true,
                        };
                        if (leadQuality === "high") {
                            try {
                                await postRequest(
                                    ApiConfig.SAVE_GET_A_CALLBACK_CTA,
                                    data,
                                    axiosConfig,
                                );
                                resetFn();
                                setPopUpType("profileEvaluationLayer");
                                setIsPopUpOpened(true);
                            } catch (err) {
                                resetFn();
                                const error: unknown = err;
                                appMonitorLogger({
                                    message: `RCB-H validate`,
                                    error,
                                });
                            }
                        } else {
                            try {
                                await postRequest(
                                    ApiConfig.SAVE_GET_A_CALLBACK_CTA,
                                    data,
                                    axiosConfig,
                                );
                                resetFn();
                                setPopUpType("success");
                                setIsPopUpOpened(true);
                            } catch (err) {
                                resetFn();
                                const error: unknown = err;
                                appMonitorLogger({
                                    message: `RCB-L validate`,
                                    error,
                                });
                            }
                        }
                    } else {
                        resetFn();
                        if (ineligibilityType === "Type_-1") {
                            alert("Something went wrong");
                            return false;
                        } else if (ineligibilityType === "Type_5") {
                            setCounselorHierarchy(counselorHierarchy);
                            setPopUpType("inCounseling");
                        } else if (ineligibilityType === "Reached_Limit_Of_Maximum_Sessions") {
                            setPopUpType("BYSLimit");
                        } else {
                            setPopUpType("failed");
                        }
                        setIsPopUpOpened(true);
                    }
                } catch (err) {
                    const error: unknown = err;
                    appMonitorLogger({message: `Exception: RCB`, error});
                }
            } else {
                resetFn();
            }
            // }
        },
        [
            dispatch,
            userId,
            resetFn,
            history,
            isMobile,
            isUserLoggedIn,
            userStageId,
            reactivationDatePassed,
        ],
    );

    //PHP one handling
    useEffect(() => {
        let data: ClickCallbackRCB | undefined;
        const requestACallBackCookie: string = getCookie("requestACallBackCookieData") as string;
        if (requestACallBackCookie !== "") {
            setCookie("requestACallBackCookieData", "", -1);
            const requestACallBackCookieData = JSON.parse(atob(requestACallBackCookie)) as {
                trackingId: {
                    requestACallBack: TrackingId;
                    register: TrackingId;
                };
                eventCategory: string;
                eventAction: string;
                widget: string;
                courseId?: CourseId;
                counselorId?: CounselorId;
            };
            data = {
                trackingId: requestACallBackCookieData.trackingId,
                showSignUpCheck: true,
                eventCategory: requestACallBackCookieData.eventCategory,
                eventAction: requestACallBackCookieData.eventAction,
                widget: requestACallBackCookieData.widget,
                courseId: requestACallBackCookieData.courseId,
                counselorId: requestACallBackCookieData.counselorId,
            };
            // console.log(requestACallBackCookieData);
            setApplicableTrackingId(requestACallBackCookieData.trackingId.requestACallBack);
        }
        if (data) {
            void onCTAClick(data);
        }
    }, [onCTAClick]);

    //Auto trigger if query params "c"
    useEffect(() => {
        if (autoTriggerBasedOnParams) {
            const searchString = location.search.substring(1);
            const params = parseQueryString(searchString);
            // console.log(params);
            let triggerOnCTAClick = true;
            let data: ClickCallbackRCB | undefined;
            if ("c" in params) {
                history.replace(location.pathname);
                const queryData = JSON.parse(
                    atob(params["c"] as string),
                ) as RequestACallbackQueryParams;
                console.log(queryData);
                if (queryData.listingTypeId && courseId) {
                    if (courseId !== queryData.listingTypeId) {
                        triggerOnCTAClick = false;
                    }
                }
                if (queryData.isTopCounsellor) {
                    setShowMoreThanOneCounsellor(true);
                }
                if (triggerOnCTAClick && queryData.trackingId) {
                    data = {
                        trackingId: {
                            requestACallBack: queryData.trackingId,
                            register: queryData.trackingId,
                        },
                        showSignUpCheck: false,
                        eventCategory,
                        eventAction,
                        widget,
                        courseId,
                        counselorId: queryData.counselorId ?? undefined,
                    };
                    setApplicableTrackingId(data.trackingId.requestACallBack);
                }
            }
            if (data) {
                void onCTAClick(data);
            }
        }
    }, [
        history,
        location,
        eventCategory,
        onCTAClick,
        eventAction,
        widget,
        autoTriggerBasedOnParams,
        courseId,
        counselorId,
    ]);

    useEffect(() => {
        return () => {
            resetFn();
        };
    }, [resetFn]);

    // for app
    useEffect(() => {
        appCTAHandle("request_callback_btn", location.search);
    }, []);
    return (
        <React.Fragment>
            {viewType == "button" ? (
                <Button
                    id="request_callback_btn"
                    orange
                    onClick={() => {
                        void onCTAClick({
                            trackingId,
                            courseId,
                            eventCategory,
                            eventAction,
                            widget,
                            counselorId,
                        });
                    }}
                >
                    {buttonLabel}
                </Button>
            ) : (
                <Anchor
                    showLinkIcon={false}
                    onClickHandle={() => {
                        void onCTAClick({
                            trackingId,
                            courseId,
                            eventCategory,
                            eventAction,
                            widget,
                            counselorId,
                        });
                    }}
                >
                    {buttonLabel}
                </Anchor>
            )}
            {isPopUpOpened && (
                <RequestACallBackCTAPopUp
                    handlePopUpStatus={setIsPopUpOpened}
                    popUpType={popUpType}
                    counselorHierarchy={counselorHierarchy}
                    userId={userId}
                    counselorId={reviewPageCounsellorId}
                    setReviewPageCounsellorId={setReviewPageCounsellorId}
                    applicableTrackingId={applicableTrackingId}
                    showMoreThanOneCounsellor={showMoreThanOneCounsellor}
                />
            )}
        </React.Fragment>
    );
};

export default RequestACallBackCTA;
